module.exports = require("../../shared/game/belot/armenian/tricks");
